import React, { FC, KeyboardEvent, MouseEvent, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface ButtonProps {
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit';
  onClick?: ( event?: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement> ) => void;
  onKeyDown?: ( event: KeyboardEvent<HTMLButtonElement> ) => void;
}

const Button: FC<PropsWithChildren<ButtonProps>> = ({
  ariaLabel,
  children,
  className,
  disabled,
  type = 'button',
  onClick,
  onKeyDown = ( event: KeyboardEvent<HTMLButtonElement> ) => {
    if ( event.key === 'Enter' || event.key === ' ' ) {
      onClick?.( event );
    }
  },
}) => (
  <button
    aria-label={ariaLabel}
    className={cls( styles.button, className )}
    disabled={disabled}
    type={type}
    onClick={onClick}
    onKeyDown={onKeyDown}
  >
    {children}
  </button>
);

export default Button;
